// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusTag_root__2jQFl","wrapper":"StatusTag_wrapper__3cO2g","label":"StatusTag_label__3yhXA","printingLabel":"StatusTag_printingLabel__LTIN9"};